import { EUserRoles, TUserRoles } from '@enums/common';

export const checkIsAdmin = (roles: Array<TUserRoles>): boolean => {
	return roles?.includes(EUserRoles.assetOwnerOrganizationAdministrator)
		|| roles?.includes(EUserRoles.networkOperatorOrganizationAdministrator)
		|| roles?.includes(EUserRoles.assetConsumerOrganizationAdministrator);
};

export const checkIsPlatformOwner = (
	roles: Array<TUserRoles>,
): boolean => roles?.includes(EUserRoles.platformOwnerAdministrator);

export const hideDefaultRole = <
	T extends { roles?: Array<{ name: string }> }
>(list: T[]): T[] => {
	return list.map((item) => ({
		...item,
		roles: item.roles?.filter((role) => role.name !== EUserRoles.defaultRole),
	}));
};

